enum OrganizationSubscriptionStatus {
  'active' = 'active',
  'past_due' = 'past_due',
  'unpaid' = 'unpaid',
  'canceled' = 'canceled',
  'incomplete' = 'incomplete',
  'incomplete_expired' = 'incomplete_expired',
  'trialing' = 'trialing',
  'paused' = 'paused',
}

export default OrganizationSubscriptionStatus
